import { render, staticRenderFns } from "./EmisiaHome.vue?vue&type=template&id=9c638ab6&scoped=true"
import script from "./EmisiaHome.vue?vue&type=script&setup=true&lang=js"
export * from "./EmisiaHome.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmisiaHome.vue?vue&type=style&index=0&id=9c638ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c638ab6",
  null
  
)

export default component.exports